import {
  Sparkles, PlayCircle, Clock, Hourglass, CheckCircle2, AlertTriangle,
  GraduationCap, Briefcase, DollarSign, Zap, BookOpen, FileText, Star,
} from 'lucide-react';

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const COLUMNS = [
  { id: 'recommended', label: 'Recommended', icon: Sparkles, dot: 'bg-slate-400', text: 'text-slate-300', ring: 'border-slate-700' },
  { id: 'ready', label: 'Ready to Start', icon: PlayCircle, dot: 'bg-cyan-400', text: 'text-cyan-300', ring: 'border-cyan-500/30' },
  { id: 'in_progress', label: 'In Progress', icon: Clock, dot: 'bg-blue-400', text: 'text-blue-300', ring: 'border-blue-500/30' },
  { id: 'waiting', label: 'Waiting on Someone', icon: Hourglass, dot: 'bg-amber-400', text: 'text-amber-300', ring: 'border-amber-500/30' },
  { id: 'completed', label: 'Completed', icon: CheckCircle2, dot: 'bg-emerald-400', text: 'text-emerald-300', ring: 'border-emerald-500/30' },
  { id: 'attention', label: 'Needs Attention', icon: AlertTriangle, dot: 'bg-rose-400', text: 'text-rose-300', ring: 'border-rose-500/40' },
];

export const CATEGORY_META = {
  academic: { label: 'Academic', icon: BookOpen, text: 'text-indigo-300', bg: 'bg-indigo-500/15' },
  college: { label: 'College', icon: GraduationCap, text: 'text-violet-300', bg: 'bg-violet-500/15' },
  career: { label: 'Career', icon: Briefcase, text: 'text-blue-300', bg: 'bg-blue-500/15' },
  financial: { label: 'Financial', icon: DollarSign, text: 'text-emerald-300', bg: 'bg-emerald-500/15' },
  skill: { label: 'Skill', icon: Zap, text: 'text-amber-300', bg: 'bg-amber-500/15' },
  certification: { label: 'Certification', icon: BookOpen, text: 'text-cyan-300', bg: 'bg-cyan-500/15' },
  application: { label: 'Application', icon: FileText, text: 'text-pink-300', bg: 'bg-pink-500/15' },
  personal: { label: 'Personal', icon: Star, text: 'text-slate-300', bg: 'bg-slate-500/15' },
  scholarship: { label: 'Scholarship', icon: DollarSign, text: 'text-emerald-300', bg: 'bg-emerald-500/15' },
};

export const PRIORITY_CLASS = {
  high: 'text-rose-300 bg-rose-500/15',
  medium: 'text-amber-300 bg-amber-500/15',
  low: 'text-emerald-300 bg-emerald-500/15',
};

export const CHANGE_FIELDS = [
  ['career_goal', 'Career goal'],
  ['college_or_program', 'College or program'],
  ['military_branch', 'Military branch'],
  ['target_date', 'Target date'],
  ['graduation_date', 'Graduation date'],
  ['location', 'Location'],
  ['gpa', 'GPA'],
  ['financial_circumstances', 'Financial circumstances'],
  ['primary_pathway', 'Primary pathway'],
  ['backup_pathway', 'Backup pathway'],
  ['education_route', 'Education route'],
  ['certification_route', 'Certification route'],
];

export const todayISO = () => new Date().toISOString().slice(0, 10);

export const fmtDate = (d) => {
  if (!d) return '—';
  const dt = new Date(`${String(d).slice(0, 10)}T00:00:00`);
  if (Number.isNaN(dt.getTime())) return String(d);
  return dt.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
};

export const isOverdue = (task) =>
  task.status !== 'completed' && task.due_date && String(task.due_date).slice(0, 10) < todayISO();

export const daysUntil = (d) => {
  if (!d) return null;
  const ms = new Date(`${String(d).slice(0, 10)}T00:00:00`) - new Date(`${todayISO()}T00:00:00`);
  return Math.round(ms / 86400000);
};
